import { render, staticRenderFns } from "./ProductShippingConfig.vue?vue&type=template&id=506a1742&scoped=true&"
import script from "./ProductShippingConfig.vue?vue&type=script&lang=js&"
export * from "./ProductShippingConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProductShippingConfig.vue?vue&type=style&index=0&id=506a1742&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a1742",
  null
  
)

export default component.exports